<template>
  <div>
		<template v-for="(item, index) in result.other.interpretation">
			<div style="font-size:18px;padding-top: 20px;" :key="index">
				中医体质为：
				<span style="color:#73B5BB;">{{ item.type }}</span>
			</div>
		
			<template v-for="(item2, index2) in item.content">
				<div :key="`${index}_${index2}`">
					<h4>{{ item2.name }}</h4>

					<div style="line-height: 1.8em; padding: 10px 20px; border: 1px solid rgb(105, 156, 228); border-radius: 5px; background: rgb(243, 248, 255); font-size: 16px;">
						<div>{{ item2.value }}</div>
					</div>
				</div>
			</template>

		</template>
  </div>

</template>

<script>
import mixin from '@/views/mixin';
import api from '@/service/api.js';

export default {  
	props: {
		result: Object
	},
	data(){
		return {}
	},
	created() {
		console.log(this.result.other.interpretation)
	},
	methods: {}
}
</script>

<style lang="less" scoped>
// @import './template.less';	
</style>
